import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './store/auth/auth.reducer';
import { AuthGuard } from './guards/auth.guard';
import { AuthInterceptorProvider } from './api/api.interceptor';
import { ApiWebSocketService } from './api/api.web-socket.service';
import { ResumeSessionGuard } from './guards/resumeSession.guard';
import { MainStateReducer } from './store/mainState/mainState.reducer';
import { globalMapReducer } from './store/globalMapState/globalMapState.reducer';
import { cityStateReducer } from './store/cityState/cityState.reducer';
import { ConfigurationsReducer } from './store/configurationState/configurationState.reducer';
import { SharedComponentsModule } from './modules/shared/shared-components.module';
import { characterStateReducer } from './store/characterState/characterState.reducer';
import { environment } from 'src/environments/environment';
import { HttpRequestInterceptor } from './api/loader.interceptor';
// import { StoreDevtoolsModule } from '@ngrx/store-devtools';
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    StoreModule.forRoot({
      configurationState: ConfigurationsReducer,
      auth: authReducer,
      mainState: MainStateReducer,
      globalMap: globalMapReducer,
      cityState: cityStateReducer,
      characterState: characterStateReducer,
    }),
    // StoreDevtoolsModule.instrument({
    //   logOnly: environment.production,
    // }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedComponentsModule,
  ],
  providers: [
    AuthGuard,
    ResumeSessionGuard,
    AuthInterceptorProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    ApiWebSocketService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
